export default function About() {
  return (
    <section id="about" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#3d2817] to-[#1a0f08]"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-8">
        <div className="mb-20">
          <div className="inline-block px-4 py-2 rounded-full bg-purple-200/20 mb-6">
            <span className="text-purple-300 text-xs uppercase tracking-wider font-medium">// WHO WE ARE</span>
          </div>
          
          <h2 className="text-5xl font-bold text-white mb-16 max-w-3xl leading-tight">
            EURIPUS d.o.o. / Expert iOS Development Team
          </h2>
          
          <div className="space-y-20 text-white/60 text-base max-w-3xl">
            <p className="leading-relaxed">
              EURIPUS d.o.o. is a dedicated team of iOS development experts committed to creating applications that make a real difference in users' daily lives. Our focus on quality and innovation drives everything we do.
            </p>
            <p className="leading-relaxed">
              We specialize in developing sophisticated mobile solutions that combine cutting-edge technology with intuitive design. Our products are built with meticulous attention to detail and a deep understanding of user needs.
            </p>
            <p className="leading-relaxed">
              Our flagship products, VPN and Cleaner, represent our commitment to enhancing mobile device security and performance. Each application is engineered to deliver exceptional results while maintaining ease of use.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-16 items-center mt-32">
          <div className="relative aspect-square rounded-3xl overflow-hidden bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/847db6784305af611e0890acf1796a5e.jpg" 
              alt="iOS Device Mockup"
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="space-y-8">
            <div className="text-white font-serif text-[180px] leading-none font-bold">2</div>
            <div>
              <h3 className="text-2xl text-white/90 font-semibold mb-3">
                Premium Products / VPN &amp; Cleaner Solutions
              </h3>
              <p className="text-white/50 text-base">
                Engineered for performance and security
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
